import React from "react";

function InfoCard(props) {
  return (
    <div className="selling-process text-center text-white">
      <div className="icon">
        <img src={props.imgSrc} alt="" />
      </div>
      <div className="content">
        <h5>{props.heading}</h5>
        <p>{props.description}</p>
      </div>
    </div>
  );
}

export default InfoCard;
